import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import SearchReport from '../../../widgets/searchSubProject/SearchReport'
import SubProjectApprovalReportWidget from '../../../widgets/searchSubProject/SubProjectApprovalReportWidget'
import { getClosureform } from '../../../redux/actions/subProjectReport'

export default function SubProjectApprovalReport() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    console.log('load ProjectName projectId')

    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getClosureform()
      console.log('res ', _schema)
      setSchema(_schema)
      // setIsEditWidget({
      //   reportSetting: _schema.forms?.reportSetting?.id ? false : true,
      // })

      // setShowEditAll(!_schema.forms?.reportSetting?.disabled)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProjectReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isSubProjectReport>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          <SubProjectApprovalReportWidget schema={schema.form} isEdit={true} />
        </SidebarProposal>
      )}
    </>
  )
}
